var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{attrs:{"pill":"","variant":"success"}},[_vm._v("Aprovado")])}
var staticRenderFns = []

export { render, staticRenderFns }